var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{class:[_vm.$style.progressBar, {
      [_vm.$style.secondary]: _vm.isSecondary,
    }]},[_c('div',{class:[_vm.$style.progressBarProgress, {
        [_vm.$style.secondaryFill]: _vm.isSecondary,
      }],style:({ width: `${100 * _vm.numComplete / _vm.numItems}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }